import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import { leadsAPI } from '../../utils/api';
import styles from './Contacto.module.css';

const CONTACT = [
  {
    id: 'wa',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    color: '#25d366',
    label: 'WhatsApp',
    value: '+54 9 11 3611-2732',
    href: 'https://wa.me/5491136112732',
    external: true,
  },
  {
    id: 'tel',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.22 2.18 2 2 0 012.2 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.16 6.16l1.27-.56a2 2 0 012.11.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
      </svg>
    ),
    color: '#cb3234',
    label: 'Teléfono',
    value: '(011) 4952-3703',
    href: 'tel:01149523703',
    external: false,
  },
  {
    id: 'mail',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
    color: '#3b82f6',
    label: 'E-mail',
    value: 'info@microled.com.ar',
    href: 'mailto:info@microled.com.ar',
    external: false,
  },
  {
    id: 'map',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    color: '#f59e0b',
    label: 'Fábrica',
    value: 'Pichincha 188, C.A.B.A.',
    href: 'https://g.page/CMYM_Microled_Argentina',
    external: true,
  },
];

export default function Contacto() {
  const [searchParams] = useSearchParams();
  const origenParam    = searchParams.get('origen')    || 'formulario';
  const categoriaParam = searchParams.get('categoria') || '';

  // Si viene de una landing, pre-llenar el mensaje con contexto
  const mensajeInicial = categoriaParam
    ? `Hola, me interesa conocer más sobre ${categoriaParam}. ¿Podrían enviarme un presupuesto?`
    : '';

  const formRef = useRef(null);

  const [form, setForm]       = useState({ nombre: '', empresa: '', telefono: '', email: '', mensaje: mensajeInicial });
  const [formSent, setFormSent] = useState(false);

  const scrollToForm = (e) => {
    e.preventDefault();
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Pequeño delay para que el scroll termine antes de enfocar
      setTimeout(() => {
        const firstInput = formRef.current.querySelector('input, textarea');
        if (firstInput) firstInput.focus();
      }, 400);
    }
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    const ahora = new Date().toISOString();

    // Capturar ga_client_id para relacionar con Analytics
    const gaCookie = document.cookie.split(';').find(c => c.trim().startsWith('_ga='));
    const gaClientId = gaCookie
      ? gaCookie.trim().replace('_ga=', '').split('.').slice(2).join('.')
      : '';

    // Guardar en servidor (API → SQLite)
    // Tags automáticos: categoría de origen si viene de una landing
    const tagsAuto = categoriaParam ? [categoriaParam] : [];

    const lead = {
      id:           `lead_${Date.now()}_${Math.random().toString(36).slice(2,6)}`,
      nombre:       form.nombre,
      empresa:      form.empresa,
      telefono:     form.telefono,
      email:        form.email,
      mensaje:      form.mensaje,
      status:       'nuevo',
      prioridad:    'media',
      tags:         tagsAuto,
      notas:        [],
      ga_client_id: gaClientId,
      origen:       origenParam,
      fecha:        ahora,
    };

    leadsAPI.create(lead).catch(() => {
      // Fallback a localStorage si el servidor no responde
      const previas = JSON.parse(localStorage.getItem('microled_contactos') || '[]');
      localStorage.setItem('microled_contactos', JSON.stringify([...previas, { ...form, fecha: ahora }]));
    });

    // Abrir WhatsApp
    const quien = form.empresa ? `${form.nombre} de ${form.empresa}` : form.nombre;
    const texto = `Hola! Soy ${quien}.\n${form.mensaje}`;
    window.open(`https://wa.me/5491136112732?text=${encodeURIComponent(texto)}`, '_blank', 'noopener,noreferrer');

    setFormSent(true);
    setTimeout(() => { setFormSent(false); setForm({ nombre: '', empresa: '', telefono: '', email: '', mensaje: mensajeInicial }); }, 4000);
  };

  return (
    <>
      <Helmet>
        <title>• Contacto | Microled Argentina 🔴</title>
        <meta name="description" content="Contactanos para solicitar presupuesto de pantallas LED y cartelería electrónica. WhatsApp: +54 9 11 3611-2732. Pichincha 188, CABA. Respondemos en 24hs." />
        <meta name="theme-color" content="#CB3234" />
        <link rel="canonical" href="https://microled.com.ar/contacto" />
      </Helmet>

      {/* Banner */}
      <div className={styles.banner} style={{ backgroundImage: `url('/img/franjas/franja_formulario.jpg')` }}>
        <div className={styles.bannerOverlay} />
        <div className={styles.bannerContent}>
          <h1 className={styles.bannerTitle}>Contacto</h1>
          <p className={styles.bannerSub}>Respondemos en menos de 24 horas hábiles</p>
        </div>
      </div>

      {/* Cuerpo: info + formulario */}
      <div className={styles.body}>

        {/* Columna izquierda — datos de contacto */}
        <div className={styles.infoCol}>
          <h2 className={styles.infoTitle}>Medios de contacto</h2>
          <div className={styles.contactList}>
            {CONTACT.map(c => (
              <a key={c.id}
                href={c.id === 'wa' ? '#formulario' : c.href}
                target={c.id !== 'wa' && c.external ? '_blank' : undefined}
                rel={c.id !== 'wa' && c.external ? 'nofollow noreferrer' : undefined}
                onClick={c.id === 'wa' ? scrollToForm : undefined}
                className={styles.contactRow}>
                <span className={styles.contactIcon} style={{ background: `${c.color}18`, color: c.color }}>
                  {c.icon}
                </span>
                <span className={styles.contactInfo}>
                  <span className={styles.contactLabel}>{c.label}</span>
                  <span className={styles.contactValue}>{c.value}</span>
                  {c.id === 'wa' && (
                    <span className={styles.contactHint}>Tocá para ir al formulario ↓</span>
                  )}
                </span>
                <span className={styles.contactArrow} style={{ color: c.color }}>→</span>
              </a>
            ))}
          </div>
          <div className={styles.mapBox}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.7012601675724!2d-58.40108148477011!3d-34.611714980457485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccae8a2d1a1b9%3A0x7f4f6da5b67bc8bf!2sCM%26M%20Microled%20F%C3%A1brica%20de%20Letreros%20Electr%C3%B3nicos%20Led!5e0!3m2!1ses-419!2sar!4v1601332920934!5m2!1ses-419!2sar"
              title="Ubicación Microled"
              loading="lazy"
              sandbox="allow-scripts allow-same-origin"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        {/* Columna derecha — formulario */}
        <div id="formulario" className={styles.formCol} ref={formRef}>
          <div className={styles.formCard}>
            <h2 className={styles.formTitle}>Solicitar presupuesto</h2>
            <p className={styles.formSub}>Completá el formulario y te respondemos por WhatsApp.</p>

            {formSent ? (
              <div className={styles.successMsg}>
                <span>✓</span>
                <p>¡Mensaje enviado! Te vamos a responder en breve.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.fieldRow}>
                  <div className={styles.field}>
                    <label>Nombre *</label>
                    <input type="text" required placeholder="Tu nombre"
                      value={form.nombre} onChange={e => set('nombre', e.target.value)} />
                  </div>
                  <div className={styles.field}>
                    <label>Empresa</label>
                    <input type="text" placeholder="Tu empresa (opcional)"
                      value={form.empresa} onChange={e => set('empresa', e.target.value)} />
                  </div>
                </div>
                <div className={styles.fieldRow}>
                  <div className={styles.field}>
                    <label>Teléfono</label>
                    <input type="tel" placeholder="11 1234-5678"
                      value={form.telefono} onChange={e => set('telefono', e.target.value)} />
                  </div>
                  <div className={styles.field}>
                    <label>E-mail</label>
                    <input type="email" placeholder="tu@email.com"
                      value={form.email} onChange={e => set('email', e.target.value)} />
                  </div>
                </div>
                <div className={styles.field}>
                  <label>¿Qué necesitás? *</label>
                  <textarea required rows={5} placeholder="Contanos qué tipo de cartelería necesitás, para qué local o empresa, y cualquier detalle relevante..."
                    value={form.mensaje} onChange={e => set('mensaje', e.target.value)} />
                </div>
                <button type="submit" className={styles.submitBtn}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Enviar por WhatsApp
                </button>
              </form>
            )}
          </div>
        </div>

      </div>
    </>
  );
}
